import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { getApi } from '../../services/api';
import './Sidebar.css';

const menuGroups = [
  {
    label: 'Main',
    items: [
      { path: '/dashboard', icon: 'bi-grid', label: 'Dashboard', end: true },
      { path: '/dashboard/profile', icon: 'bi-person', label: 'Profile' },
    ],
  },
  {
    label: 'Finance',
    items: [
      { path: '/dashboard/stake', icon: 'bi-layers', label: 'Stake' },
      { path: '/dashboard/wallet', icon: 'bi-wallet2', label: 'Wallet' },
      { path: '/dashboard/deposit', icon: 'bi-arrow-down-circle', label: 'Deposit' },
      { path: '/dashboard/withdraw', icon: 'bi-arrow-up-circle', label: 'Withdraw' },
    ],
  },
  {
    label: 'Network',
    items: [
      { path: '/dashboard/team', icon: 'bi-people', label: 'Team' },
      { path: '/dashboard/rank', icon: 'bi-trophy', label: 'Rank' },
    ],
  },
  {
    label: 'Account',
    items: [
      { path: '/dashboard/settings', icon: 'bi-gear', label: 'Settings' },
      { path: '/dashboard/support', icon: 'bi-headset', label: 'Support' },
    ],
  },
];

const Sidebar = ({ isOpen, onClose }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getApi('profile');
        if (response.data?.status === true || response.status === true) {
          setUserData(response.data?.USER || response.USER);
        }
      } catch (error) {
        console.error('Sidebar profile fetch error:', error);
      }
    };
    fetchProfile();
  }, []);

  const handleLinkClick = () => {
    if (window.innerWidth < 992) {
      onClose();
    }
  };

  return (
    <>
      {/* Mobile overlay */}
      <div
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />

      <aside className={`sidebar ${isOpen ? 'active' : ''} ${collapsed ? 'sidebar-collapsed' : ''}`}>
        {/* Header */}
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="logo-icon">
              <i className="bi bi-hexagon-fill"></i>
            </div>
            {!collapsed && (
              <>
                <span className="logo-text">ANTIPSUN</span>
                <span className="logo-badge">PRO</span>
              </>
            )}
          </div>
          <div className="sidebar-header-actions">
            {/* Collapse toggle — desktop only */}
            <button
              className="btn btn-link sidebar-collapse-btn d-none d-lg-flex"
              onClick={() => setCollapsed(!collapsed)}
              title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            >
              <i className={`bi ${collapsed ? 'bi-chevron-right' : 'bi-chevron-left'}`}></i>
            </button>
            {/* Close button — mobile only */}
            <button
              className="btn btn-link sidebar-close d-lg-none"
              onClick={onClose}
              aria-label="Close menu"
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </div>

        {/* User Info */}
        <div className="sidebar-user">
          <div className="user-avatar-wrap">
            <img
              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(userData?.name || 'User')}&background=00FFB3&color=050A15`}
              alt="User avatar"
              className="user-img"
            />
            <span className="user-status-dot" title="Online"></span>
          </div>
          {!collapsed && (
            <div className="user-info">
              <h6 className="user-name">{userData?.name || 'USER'}</h6>
              <span className="user-rank">
                <i className="bi bi-gem"></i>
                {userData?.rank_name || 'Member'}
              </span>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav" aria-label="Dashboard navigation">
          {menuGroups.map((group) => (
            <div key={group.label} className="nav-group">
              {!collapsed && (
                <span className="nav-group-label">{group.label}</span>
              )}
              <ul className="nav-list" role="list">
                {group.items.map((item) => (
                  <li key={item.path} className="nav-item" role="listitem">
                    <NavLink
                      to={item.path}
                      end={item.end}
                      className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                      onClick={handleLinkClick}
                      title={collapsed ? item.label : undefined}
                    >
                      <span className="nav-icon-wrap">
                        <i className={`bi ${item.icon}`}></i>
                      </span>
                      {!collapsed && <span className="nav-label">{item.label}</span>}
                      {!collapsed && <span className="nav-indicator" aria-hidden="true"></span>}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          <NavLink to="/logout" className="logout-btn" title={collapsed ? 'Logout' : undefined}>
            <i className="bi bi-box-arrow-right"></i>
            {!collapsed && <span>Logout</span>}
          </NavLink>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;